console.time();
window.addEventListener('load', function() {
    //   if(window.location.href.indexOf("krinklewood-wine-club") > -1) {
    //     $('#rb-options--0 #rb-options--00 ').removeClass('rb-option--selected');
    //     $('#rb-options--1 #rb-options--10 ').removeClass('rb-option--selected');
    //   }
  
    function unwrap(wrapper) {
      // place childNodes in document fragment
      var docFrag = document.createDocumentFragment();
      while (wrapper.firstChild) {
          var child = wrapper.removeChild(wrapper.firstChild);
          docFrag.appendChild(child);
      }

      // replace wrapper with document fragment
      wrapper.parentNode.replaceChild(docFrag, wrapper);
  }

  
  	const myTimeout = setTimeout(rechargeCustom, 2000);
  
    function rechargeCustom() {
       if (window.location.href.indexOf("corporate-membership") > -1) {
        document.querySelector('#rb-options--03.rb-option').click(e);

        const el = document.querySelector('#rb-options--1');
        const y = el.getBoundingClientRect().top + window.pageYOffset - 75;

        window.scrollTo({ top: y, behavior: 'smooth' });
         
    }

    const productSelectors = document.querySelectorAll("#rb-options--0 .rb-option");

    for (let i = 0; i < productSelectors.length; i++) {
        productSelectors[i].addEventListener("click", function(e) {
            e.target.classList.add('rb-option--selected');
            const el = document.querySelector('#rb-options--1');
            const y = el.getBoundingClientRect().top + window.pageYOffset - 75;
			console.log('Box Size selected');
            window.scrollTo({ top: y, behavior: 'smooth' });

        });
    }

    const productsType = document.querySelectorAll("#rb-options--1 .rb-option");

    for (let i = 0; i < productsType.length; i++) {
        productsType[i].addEventListener("click", function() {
            const el = document.querySelector('.rb-step-footer');
            const y = el.getBoundingClientRect().top + window.pageYOffset - 115;
			console.log('Box Type selected');
            window.scrollTo({ top: y, behavior: 'smooth' });

        });
    }
      
    

    function createListeners() {
        const freqSelect = document.querySelectorAll(".rb-step-footer a, .rb-step-footer button, .rb-step-anchor");

        for (let i = 0; i < freqSelect.length; i++) {
            freqSelect[i].addEventListener("click", moveButtons);
        }

        function moveButtons() {

            //console.log(this);

            if (this.classList.contains('dupeCart')) {
                document.querySelector('.rb-footer-actions .rb-btn').click();
            }

            if (this.classList.contains('dupeBack')) {
                document.querySelector('.rb-footer-actions .rb-back-link').click();
            }


            const el = document.querySelector('.rb-step-header');
            const y = el.getBoundingClientRect().top + window.pageYOffset;

            window.scrollTo({ top: y, behavior: 'smooth' });

            let currentStep = document.querySelector('.rb-multi-step .rb-nav').getAttribute('data-step');


            if (currentStep == 3) {
                if (document.querySelector('.duplicatedFooter') != null) {
                    document.querySelector('.duplicatedFooter').remove();
                }

                var footer = document.createElement('footer');
                footer.className = 'rb-step-footer duplicatedFooter';

                var footerActions = document.createElement('div');
                footerActions.className = 'rb-footer-duplicate-actions';

                var rbBtn = document.createElement('a');
                rbBtn.innerHTML = 'Add to cart';
                rbBtn.className = 'rb-btn btn mb3 dupeCart';

                var rbBack = document.createElement('a');
                rbBack.innerHTML = 'Go back';
                rbBack.className = 'rb-back-link db dupeBack';

                document.querySelector('.rb-frequency-wrapper').appendChild(footer).appendChild(footerActions);

                document.querySelector('.rb-footer-duplicate-actions').appendChild(rbBtn);

                document.querySelector('.rb-footer-duplicate-actions').appendChild(rbBack);


                for (let i = 0; i < freqSelect.length; i++) {

                    freqSelect[i].removeEventListener("click", moveButtons);
                }

                createListeners();

            }

            // Duplicate quantity helper button
          
          console.log('currentStep: ' + currentStep);
          
          	// Remove element 
          
          	const headerQty = document.getElementById('header-quantity');
              
              	if (typeof(headerQty) != 'undefined' && headerQty != null) {
                	headerQty.remove();
                } 
			
            if (currentStep == 2) {
              
              // Update product item structure
              
              //unwrap(document.querySelectorAll('.rb-item-content'));
              
              jQuery('.rb-item .rb-title').unwrap();
              
              // Clone button
              
                let footerCount = document.querySelector('.rb-footer-actions button.rb-btn');
                let clonedFooter = footerCount.cloneNode(true);
                clonedFooter.id = 'header-quantity';              	
              
              	document.querySelector('.rb-step-header').appendChild(clonedFooter);

                let qtyBtn = document.querySelectorAll('.rb-btn-qty');
                let qtyInput = document.querySelectorAll('.rb-qty-wrapper .rb-input');

                function updateQtyBtn() {
                    let qtyElement = document.querySelector('.rb-footer-actions .rb-notice');
                    if (typeof(qtyElement) != 'undefined' && qtyElement != null) {
                        console.log('Element exists!');
                        let qtyText = document.querySelector('.rb-footer-actions .rb-notice').innerHTML;
                        document.querySelector('.rb-step-header .rb-notice').innerHTML = qtyText;
                        document.querySelector('.rb-step-header button.rb-btn').style.display = "inline-block";
                    } else {
                        console.log('Element does not exist!');
                        document.querySelector('.rb-step-header button.rb-btn').style.display = "none";
                    }
                }

                // Update on button click
                for (let i = 0; i < qtyBtn.length; i++) {
                    qtyBtn[i].addEventListener("click", updateQtyBtn);
                }

                // Update on input change
                for (let i = 0; i < qtyInput.length; i++) {
                    qtyInput[i].addEventListener("change", updateQtyBtn);
                }
              
              // Back button
              
              let backBtn = document.querySelector('.rb-footer-actions .rb-back-link');
              backBtn.addEventListener("click", function(){
                document.getElementById('header-quantity').remove();
              });

            }
          
          // Step 3
          
          if(currentStep == 3) {
            $('.rb-order').prepend('<h4 class="rb-order-title tf3">Your Order</h4>');
          }

		
        }
    }

    createListeners();
  	}

});

console.log('krinklewood.js [Recharge bundle] theme');